/** Local-date-safe ISO (YYYY-MM-DD) <-> Date conversion for DatePicker values.
 *  Avoids the UTC-midnight shift of `new Date("YYYY-MM-DD")` / `toISOString()`,
 *  which renders the previous day in timezones west of UTC. */

export const toIsoDate = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const fromIsoDate = (s: string | null): Date | null =>
  s ? new Date(`${s}T00:00:00`) : null;
